import { render, staticRenderFns } from "./OrmBatchingListSideMenu.vue?vue&type=template&id=678ec932&scoped=true"
import script from "./OrmBatchingListSideMenu.vue?vue&type=script&lang=js"
export * from "./OrmBatchingListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./OrmBatchingListSideMenu.vue?vue&type=style&index=0&id=678ec932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678ec932",
  null
  
)

export default component.exports